import { useEffect } from "react";
import About from "./About";
import Board from "./Board";
import ContactSection from "./ContactSection";
import Domains from "./Domains";
import Events from "./Events";
import Faculty from "./Faculty";
import Footer from "./Footer";
import Memories from "./Memories";
import "../CSS/MainPage.css";
import NewBlog from "./NewBlog";
import PixelBlast from "../PixelBlast/PixelBlast";
import MainPageHomeSection from "./MainPageHomeSection";

const MainPageContent = ({ onScrollToTop, sectionsOnly = false }) => {
  useEffect(() => {
    const resizeObserverErrorHandler = (e) => {
      if (
        e.message ===
          "ResizeObserver loop completed with undelivered notifications." ||
        e.message === "ResizeObserver loop limit exceeded"
      ) {
        e.stopImmediatePropagation();
        return false;
      }
    };

    const errorHandler = (event) => {
      if (event.message && event.message.includes("ResizeObserver")) {
        event.stopImmediatePropagation();
        event.preventDefault();
        return false;
      }
    };

    window.addEventListener("error", resizeObserverErrorHandler);
    window.addEventListener("error", errorHandler, true);

    const unhandledRejectionHandler = (event) => {
      if (
        event.reason &&
        event.reason.message &&
        event.reason.message.includes("ResizeObserver")
      ) {
        event.preventDefault();
        return false;
      }
    };
    window.addEventListener("unhandledrejection", unhandledRejectionHandler);

    return () => {
      window.removeEventListener("error", resizeObserverErrorHandler);
      window.removeEventListener("error", errorHandler, true);
      window.removeEventListener(
        "unhandledrejection",
        unhandledRejectionHandler
      );
    };
  }, []);

  return (
    <div className="main-page-content">
      {!sectionsOnly && <MainPageHomeSection onScrollToTop={onScrollToTop} />}

      <div style={{ position: "relative", isolation: "isolate" }}>
        <div
          style={{
            position: "fixed",
            top: "0px",
            left: 0,
            width: "100vw",
            height: "100vh",
            zIndex: -10,
            pointerEvents: "none",
            overflow: "hidden",
            willChange: "transform",
            background: "#1E1E1E",
          }}
        >
          <PixelBlast
            variant="circle"
            pixelSize={6}
            color="#1b4654"
            patternScale={3}
            patternDensity={1.4}
            pixelSizeJitter={0.5}
            enableRipples
            rippleSpeed={0.4}
            rippleThickness={0.12}
            rippleIntensityScale={1.5}
            liquid
            liquidStrength={0.12}
            liquidRadius={1.2}
            liquidWobbleSpeed={5}
            speed={0.6}
            edgeFade={0.25}
            transparent
          />
        </div>

        <div style={{ position: "relative", zIndex: 1 }}>
          <About />
          <Domains />
          <Events />
          <NewBlog />
          <Board />
          <Faculty />
          <Memories />
          <ContactSection />
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default MainPageContent;
